import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import { bikeEnumToNumStatuses } from "data/bike-numeric-statuses";

import {
  requestBikeStatuses,
  requestBikeListNoPagination,
  requestUpdateBikeStatus,
  requestUpdateBike,

  requestGetAlertTypes,
  requestGetAlerts,
} from "actions/bike/requests";

import {
  BIKE_LOADING,
  BIKE_ERROR,
  BIKE_GET_STATUSES,
  BIKE_FILTERS,
  BIKE_LIST,
  BIKE_LIST_NO_PAGINATION,
  BIKE_GET_SINGLE,
  BIKE_UPDATE_STATUS,
  BIKE_UPDATE,

  BIKE_GET_ALERT_TYPES,
  BIKE_GET_ALERTS,
  BIKE_SET_ALERT,
} from "actions/bike/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";
import filterTypes from "../../data/filter-types";

export const setLoading = (status) => ({
  type: BIKE_LOADING,
  payload: status
});

export const getBikeStatuses = () => dispatch => {
  requestBikeStatuses()
    .then((response) => {
      dispatch({
        type: BIKE_GET_STATUSES,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getBikeList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bike", page, size, sort, filters)
    .then((response) => {
      dispatch({
        type: BIKE_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getBikeListNoPagination = (filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestBikeListNoPagination(filters)
    .then((response) => {
      dispatch({
        type: BIKE_LIST_NO_PAGINATION,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const resetBikeListNoPagination = () => dispatch => {
  dispatch({
    type: BIKE_LIST_NO_PAGINATION,
    payload: []
  });
};

export const getSingleBike = (bikeId) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bike", null, 1, null, [{
    fieldName: "id",
    fieldValue: bikeId,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      dispatch({
        type: BIKE_GET_SINGLE,
        payload: response && response.content && response.content[0]
          ? response.content[0]
          : {}
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getSingleBikeByFilters = (filters, callback = false) => dispatch => {
  dispatch(setLoading(true));
  requestBikeListNoPagination(filters)
    .then(response => {
      const bike = response.data && response.data && response.data[0]
        ? response.data[0]
        : {};
      if (callback) {
        callback(bike);
      } else {
        dispatch({
          type: BIKE_GET_SINGLE,
          payload: bike
        });
      }
    })
    .catch((error) => {
      if (callback) {
        callback({});
      }
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const updateBikeStatus = (bikeId, status) => dispatch => {
  dispatch(setLoading(true));
  requestUpdateBikeStatus(bikeId, status)
    .then(() => {
      dispatch({
        type: BIKE_UPDATE_STATUS,
        payload: {
          id: bikeId,
          status: bikeEnumToNumStatuses[status]
        }
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const updateBike = (bike) => dispatch => {
  dispatch(setLoading(true));
  requestUpdateBike(bike)
    .then(() => {
      dispatch({
        type: BIKE_UPDATE,
        payload: bike
      });
      toast("Bike updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getBikeFilters = () => dispatch => {
  requestCommonFilters("bike")
    .then((response) => {
      dispatch({
        type: BIKE_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getAlertTypes = () => dispatch => {
  requestGetAlertTypes()
    .then((response) => {
      dispatch({
        type: BIKE_GET_ALERT_TYPES,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const getAlerts = () => dispatch => {
  requestGetAlerts()
    .then((response) => {
      dispatch({
        type: BIKE_GET_ALERTS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BIKE_ERROR));
    });
};

export const setAlert = (alert) => dispatch => {
  dispatch({
    type: BIKE_SET_ALERT,
    payload: alert
  });
};



// WEBPACK FOOTER //
// ./src/actions/bike/actions.js